export class CopyinCheckinCheckoutModel {
	public id: number;
	public workfileId: string;
	public projectNumber: string;
	public entityName: string;
	public entryId: number;
	public isMaster: boolean;

	public constructor(params: Required<CopyinCheckinCheckoutModel>) {
		this.id = params.id;
		this.workfileId = params.workfileId;
		this.projectNumber = params.projectNumber;
		this.entityName = params.entityName;
		this.entryId = params.entryId;
		this.isMaster = params.isMaster;
	}
}
